import React from "react";
import styles from "./styles.module.scss";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";
import { useQuery } from "@tanstack/react-query";
import { useForm } from "@severalbrands/form-fusion";

const MarketingMessage = () => {
    const { toggleModal, setStep } = useForm();
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <div className="flex flex-col items-center justify-center">
            <h2 className={`${styles["modalFormText"]} pe-8 mt-auto`}>
                {translate(translations, "several_general_formModalText")}
                <span
                    style={{
                        color: "#F9BB21",
                        marginLeft: "1rem",
                        padding: "0",
                    }}
                >
                    →
                </span>
            </h2>
            <p
                className="text-[#ffffff64] text-[16px] font-normal underline self-start cursor-pointer w-fit mt-auto"
                onClick={() => {
                    toggleModal({ show: false });
                    setStep({ step: 0 });
                }}
            >
                {translate(
                    translations,
                    "several_general_formModalBackPreviousPage",
                )}
            </p>
        </div>
    );
};

export default MarketingMessage;
